import React from 'react';
import logo from './assets/logo.svg';
import './App.css';
import ClickCounter from './components/ClickCounter';

function App() {
  return (
    <div className="App-header">
      <img src={logo} className="App-logo" alt="logo" />
      <h2>New Website coming soon!!!</h2>
    </div>
  );
}

export default App;
